import { createRootRoute, Outlet } from "@tanstack/react-router";
// import { TanStackRouterDevtools } from "@tanstack/router-devtools";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import AuthProvider from "@/lib/auth/AuthProvider";
import { HeroUIProvider, ToastProvider } from "@heroui/react";
import FeatureFlagProvider from "@/lib/featureFlags/FeatureFlagProvider";
import { LayoutProvider } from "@/lib/layout/LayoutProvider";
import { RequestProvider } from "@/lib/request/RequestProvider";
import ConfirmProvider from "@/lib/confirm/ConfirmProvider";
// import { isLocalhost } from "@/lib/utils/env";
import InstallPrompt from "@/components/utility/InstallPrompt";
import SessionPreferencesProvider from "@/lib/sessionPreferences/SessionPreferencesProvider";
import { TourProvider } from "@/lib/tour/TourContext";
import { I18NProvider } from "@/lib/i18n/useI18n";

const RootComponent = () => {
    return (
        <SessionPreferencesProvider>
            <HeroUIProvider>
                <ToastProvider placement="bottom-left" />
                <RequestProvider>
                    <ConfirmProvider>
                        <AuthProvider>
                            <I18NProvider>
                                <FeatureFlagProvider>
                                    <LayoutProvider>
                                        <TourProvider>
                                            <Outlet />
                                        </TourProvider>
                                    </LayoutProvider>
                                </FeatureFlagProvider>
                            </I18NProvider>
                        </AuthProvider>
                    </ConfirmProvider>
                    {/* {isLocalhost() && (
                        <>
                            <TanStackRouterDevtools />
                            <ReactQueryDevtools />
                        </>
                    )} */}
                    <InstallPrompt />
                </RequestProvider>
            </HeroUIProvider>
        </SessionPreferencesProvider>
    );
};

export const Route = createRootRoute({
    component: RootComponent,
});
